import ThreeDotMenu from "../../../../global/components/ThreeDotMenu";
import { CoAppLightTooltip } from "../../../../global/styled/global.styled";
import IdpGroupAutocompleteCell from "../IdpGroupAutocompleteCell";
import { ScimWizardRoleNameCell } from "../styled/scim-wizard.styled";

export const getStep5RoleColumns = (
	identityProviderName,
	idpGroups,
	mappedRoles,
	setMappedRoles,
	apiRef,
	validateSuperAdminRoleIsMapped,
	roleMappingStatus,
	initializeExternalGroups,
	setIdpGroups,
	toggleEditRoleDialog,
	toggleDeleteRoleDialog
) => [
	{
		field: "name",
		headerName: "CoApp roles",
		sortable: true,
		flex: 1,
		renderCell: (params) => <ScimWizardRoleNameCell variant="body2" noWrap={true} superadmin={params.row.isProtected ? "true" : "false"}>{params.value}</ScimWizardRoleNameCell>
	},
	{
		field: "idpGroups",
		headerName: `${identityProviderName} groups`,
		sortable: false,
		flex: 1,
		renderCell: (params) => (
			<IdpGroupAutocompleteCell
				options={idpGroups}
				mapped={mappedRoles}
				setMapped={setMappedRoles}
				resourceName={params.row.name}
				apiRef={apiRef}
				isProtected={params.row.isProtected}
				validateSuperAdminRoleIsMapped={validateSuperAdminRoleIsMapped}
				roleMappingStatus={roleMappingStatus}
				initializeGroupOptions={initializeExternalGroups}
				setExternalGroups={setIdpGroups}
			/>
		)
	},
	{
		field: "actions",
		type: "actions",
		sortable: false,
		flex: .1,
		renderCell: (params) => (
			params.row.isProtected ?
				<CoAppLightTooltip title="Protected role cannot be edited" placement="right">
					<div>
						<ThreeDotMenu options={[]} isCoAppSupport={true} />
					</div>
				</CoAppLightTooltip>
				:
				<div>
					<ThreeDotMenu
						options={[
							{
								name: "Edit",
								optionClickHandler: () => {
									toggleEditRoleDialog(params.row);
								},
							},
							{
								name: "Delete",
								optionClickHandler: () => {
									toggleDeleteRoleDialog(params.row);
								},
							},
						]}
					/>
				</div>
		)
	}
];